import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { updateFlyerElement } from '../../../actions/index'
import toJS from '../../../hoc/toJS'
import getData from '../../../functions/getData'
import { FLYER_DATA } from '../../../constants/state'
import EditElement from '../present/EditElement'
import { GRID_IMAGE, IMAGE, METRO, MOVIE_PERFORMANCES, TEXT, TITLE } from '../../../constants/itemTypes'


const mapStateToProps = (state, ownProps) => ({
    flyerData: getData(state, FLYER_DATA)
})


const mapDispatchToProps = (dispatch, ownProps) => ({
    onUpdateItem: (itemData,  elementType) => {
        dispatch(updateFlyerElement(elementType, itemData))
    }
})

const EditElementContainer = ({flyerData, onUpdateItem, itemType, closePagePath, itemId}) => {
    let itemData

    if(!flyerData) {
        return ''
    }

    if(itemType === IMAGE) {
        itemData = flyerData.imageElements.items[itemId]
    } else if (itemType === TEXT) {
        itemData = flyerData.textElements.items[itemId]
    } else if (itemType === TITLE) {
        itemData = flyerData.headlineElements.items[itemId]
    } else if(itemType === METRO) {
        itemData = flyerData.metroElements.items[itemId]
    } else if(itemType === MOVIE_PERFORMANCES)  {
        itemData = flyerData.moviePerformances.items[itemId]
    } else if(itemType === GRID_IMAGE) {
        itemData = flyerData.gridImages.items[itemId]
    }

    if(!itemData) {
        return ''
    }

    return <EditElement
        itemData={itemData}
        closePagePath={closePagePath}
        onUpdateItem={onUpdateItem}
        itemType={itemType}
    />
}


export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    toJS()
)(EditElementContainer)